<template>
    <entity-list
        entity="ritual"
        api-name="ritualCircles"
        :entity-headers="headers"
        :entity-archive-headers="archiveHeaders"
        read-route-name="readRitualCircle"
        new-route-name="newRitualCircle"
        :use-events="false"
        isArchive
    >
    </entity-list>
</template>
<script>
import EntityList from '../../components/EntityList'
export default {
    name: 'RitualCircleList',
    components: {
        'entity-list': EntityList,
    },
    data() {
        return {
            archiveHeaders: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                    width: '25%',
                },
                {
                    text: 'Size',
                    align: 'start',
                    value: 'size',
                    width: '10%',
                },
                { text: 'Main Team', value: 'teamName', filterable: false, width: '20%' },
                { text: 'Archive Date', value: 'archiveDate', filterable: false, width: '20%' },
            ],
        }
    },
}
</script>
